import React, { useCallback } from "react";

import { faChevronLeft } from "@fortawesome/pro-solid-svg-icons/faChevronLeft";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Layout from "antd/es/layout";
import Menu from "antd/es/menu";
import cn from "classnames";
import { defineMessage, useIntl } from "react-intl";
import { Link } from "react-router-dom";

import ReportType from "@app/enum/ReportType";

import { reportsExportsAnalytics } from "../reportsAnalytics";

import styles from "./ExportEditNavigation.module.scss";

interface Props {}

const backMessage = defineMessage({
  id: "export.navigation.back.title",
  defaultMessage: "Back to Exports",
  description: "Back to Exports link title",
});

const ExportEditNavigation: React.FC<Props> = () => {
  const intl = useIntl();

  const handleCancel = useCallback(() => reportsExportsAnalytics.cancelled("Edit"), []);

  return (
    <Layout.Header className={styles.container}>
      <Menu className={cn(styles.menuContainer, styles.exportEditMenuContainer)} mode="horizontal">
        <Menu.Item className={styles.exportEditMenuItem} key={ReportType.EXPORTS}>
          <Link onClick={handleCancel} to={`/reports/${ReportType.EXPORTS}`}>
            <FontAwesomeIcon icon={faChevronLeft} />
            &nbsp; {intl.formatMessage(backMessage)}
          </Link>
        </Menu.Item>
      </Menu>
    </Layout.Header>
  );
};

export default ExportEditNavigation;
